export enum CandidateProfileDetailType {
  CANDIDATE_PROFILE_DETAILS = 'CANDIDATE_PROFILE_DETAILS',
  TALENT_POOL_CANDIDATE_PROFILE_DETAILS = 'TALENT_POOL_CANDIDATE_PROFILE_DETAILS',
  TALENT_POOL_ADD_CANDIDATES_CANDIDATE_PROFILE_DETAILS = 'TALENT_POOL_ADD_CANDIDATES_CANDIDATE_PROFILE_DETAILS',
  ANALYSE_CANDIDATE_PROFILE_DETAILS = 'ANALYSE_CANDIDATE_PROFILE_DETAILS',
  ANALYSE_TALENT_POOL_CANDIDATE_PROFILE_DETAILS = 'ANALYSE_TALENT_POOL_CANDIDATE_PROFILE_DETAILS'
}

export type CandidateProfileDetailProps =
  | {
      type: CandidateProfileDetailType.CANDIDATE_PROFILE_DETAILS;
      candidateProfileId: string;
    }
  | {
      type: CandidateProfileDetailType.TALENT_POOL_CANDIDATE_PROFILE_DETAILS;
      candidateProfileId: string;
      talentPoolId: string;
    }
  | {
      type: CandidateProfileDetailType.TALENT_POOL_ADD_CANDIDATES_CANDIDATE_PROFILE_DETAILS;
      candidateProfileId: string;
      talentPoolId: string;
    }
  | {
      type: CandidateProfileDetailType.ANALYSE_CANDIDATE_PROFILE_DETAILS;
      candidateProfileId: string;
      candidateBatchId: string;
    }
  | {
      type: CandidateProfileDetailType.ANALYSE_TALENT_POOL_CANDIDATE_PROFILE_DETAILS;
      candidateProfileId: string;
      candidateBatchId: string;
      talentPoolId: string;
    };
